import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import { PropTypes } from "prop-types";
import moment from "moment";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ConversionTrendChart({ days, loading, error }) {
  const { labels, values, average } = useMemo(() => {
    const safe = Array.isArray(days) ? days : [];
    const lbls = safe.map((d) =>
      moment(d.date, "YYYYMMDD").format("MMM D")
    );
    const vals = safe.map((d) =>
      d.step0 ? (d.completed / d.step0) * 100 : 0
    );
    const validVals = vals.filter((_, i) => safe[i].step0 > 0);
    const avg = validVals.length
      ? validVals.reduce((a, b) => a + b, 0) / validVals.length
      : 0;
    return { labels: lbls, values: vals, average: avg };
  }, [days]);

  const data = {
    labels,
    datasets: [
      {
        label: "Conversion (%)",
        data: values,
        borderColor: "#c2608e",
        backgroundColor: "rgba(194, 96, 142, 0.14)",
        fill: true,
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#c2608e",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: { display: false },
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `Conversion: ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: { grid: { display: false } },
      y: {
        beginAtZero: true,
        ticks: { callback: (v) => `${v}%` },
        grid: { color: "#f1edf3" },
      },
    },
  };

  if (loading) {
    return (
      <div className="lb-chart-state">
        <FontAwesomeIcon spin icon={faSpinner} style={{ fontSize: 22 }} />
        <span>Loading trend…</span>
      </div>
    );
  }

  if (error) {
    return <div className="lb-chart-state">Couldn’t load the trend: {error}</div>;
  }

  if (!days || days.length === 0) {
    return <div className="lb-chart-state">No data available for this range.</div>;
  }

  return (
    <div>
      <div className="lb-chart lb-chart--line">
        <Line options={options} data={data} />
      </div>
      <div className="lb-chart-foot" style={{ gridTemplateColumns: "1fr" }}>
        <div>
          <div className="lb-chart-foot__label">7-day average conversion</div>
          <div
            className="lb-chart-foot__value"
            style={{ color: average >= 20 ? "#198754" : "#d6455d" }}
          >
            {average.toFixed(1)}%
          </div>
        </div>
      </div>
    </div>
  );
}

ConversionTrendChart.propTypes = {
  days: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

export default ConversionTrendChart;
